import { render, staticRenderFns } from "./CashAdvanceApproval.vue?vue&type=template&id=85f344c2&"
import script from "./CashAdvanceApproval.vue?vue&type=script&lang=js&"
export * from "./CashAdvanceApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports